export default __webpack_public_path__ + "static/media/g10.c0f2a0ae.svg";